export default __webpack_public_path__ + "static/danielkoch-73c6f2a34336275951e555a47e3839da.svg";